import { HttpClient } from "@angular/common/http";
import { Injectable, OnInit } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Baseproperties } from "../../utility/baseproperties";
import { Router } from "@angular/router";

@Injectable({providedIn: 'root'})
export class UserLogService implements  OnInit{
  exceldownloadModal=false; 
  items: any;
  tabIndexvalue=new BehaviorSubject<any>(0);

    baseproperties: Baseproperties = new Baseproperties();
    private baseURL = this.baseproperties.gatewayBaseURL+'/common'; 
    constructor(private httpClient:HttpClient,private route:Router,private schedularlogservice:UserLogService){}
  ngOnInit(){
  }
    refreshfilter=new BehaviorSubject<any>('');
    filtersObservable=new BehaviorSubject<any>(''); 
    logtype: string = "";
    user: string = ""; 
    location: string = "";
    department: string = ""; 
    from_date :any='';
    to_date :any='';
    page: number ;
    size: number ;
    

  filterrefresh(){
    this.refreshfilter.next('refresh');
  }
  getFilterChange(filterdata){ 
    this.filtersObservable.next(filterdata)
  }
  get_all_userlogdata() : Observable<any>{
    return this.httpClient.get(`${this.baseURL}/useraccesslog/getalluserLogs`);
  }
  get_log_type() : Observable<any>{
    return this.httpClient.get(`${this.baseURL}/useraccesslog/getlogType`);
  }
  get_product(filterdata) : Observable<any>{
    return this.httpClient.post(`${this.baseURL}/useraccesslog/getProduct`, filterdata);
  }
  get_schedular(filterdata) : Observable<any>{
    return this.httpClient.post(`${this.baseURL}/useraccesslog/getSchedule`, filterdata);
  }
  get_user(filterdata) : Observable<any>{
    return this.httpClient.post(`${this.baseURL}/useraccesslog/getUser`, filterdata);
  }
  get_location(filterdata) : Observable<any>{
    return this.httpClient.post(`${this.baseURL}/useraccesslog/getLocation`, filterdata);
  }
  get_department(filterdata) : Observable<any>{
    return this.httpClient.post(`${this.baseURL}/useraccesslog/getDepartment`, filterdata);
  }
  get_filtered_userlog_data(payload: any) : Observable<any>{ 
    return this.httpClient.post(`${this.baseURL}/useraccesslog/getFilteredUserLogData`,payload);
  }
  count_userlog_data(filterdata): Observable<any> {    
    return this.httpClient.post(`${this.baseURL}/useraccesslog/userlogdatacount`, filterdata);
  }
  get_userlog_data(filterdata): Observable<any> { 
    return this.httpClient.post(`${this.baseURL}/useraccesslog/getUserlogTableData`, filterdata);
  }
  userlog_data_excel(payload){ 
    return this.httpClient.post(`${this.baseURL}/useraccesslog/userlogDataExcel`,payload,{ responseType: 'blob' }); 
  }
}